import { setUrlWithCustomSubpage } from 'src/utils';

export const getCongestionReportUrl = (
  name: string | undefined,
  congestionType: string | undefined,
  link: string | undefined
) => {
  const subLink = name && congestionType ? `${name}/${congestionType}` : undefined;
  return link && subLink ? setUrlWithCustomSubpage(link, subLink) : undefined;
};

